module.exports = __webpack_public_path__ + "img/shout-icon-success.e5c806e9.png";